import { render, staticRenderFns } from "./AspediaCRMGridApp.vue?vue&type=template&id=6c10e174"
import script from "./AspediaCRMGridApp.vue?vue&type=script&lang=js"
export * from "./AspediaCRMGridApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports